export const UNIT = {
  '%': {
    label: 'companyAnalysis.industryAnalysis.PERCENT',
    key: '%',
  },
  days: {
    label: 'companyAnalysis.industryAnalysis.DAYS',
    key: 'days',
  },
  times: {
    label: 'companyAnalysis.industryAnalysis.TIMES',
    key: 'times',
  },
  value: {
    key: 'VND',
  },
}
